export default __webpack_public_path__ + "static/media/25.ebd83e52.jpg";